import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {AuthService} from '@core/auth/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private _auth: AuthService, private _router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot) {
    // console.log("checking route:" + JSON.stringify(route.url));

    let isLoggedIn: boolean = this._auth.isLoggedIn();
    let isAdmin: boolean = this._auth.isAdmin();

    // console.log("isLoggedIn:" + isLoggedIn + ",isAdmin:" + isAdmin + ",simulateNotLoggedIn:" + this.simulateNotLoggedIn);

    if (!isLoggedIn) {
      console.log('Not Logged in!!!');
      this._router.navigate(['login']);
      return false;
    }

    if (!isAdmin) {
      console.log('Not An Admin!');
      this._router.navigate(['unauthorizedAccess']);
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/auth/auth-guard.service.ts